import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../../common/http/fetch-get';
import { getProductTypeUrlSuffix } from '../../../common/utilities/get-product-type-url-suffix';
import { getMarketingDocumentsApiConfig } from '../config/actions';
/**
 * @internal
 */
export var fetchSubEntities = function (entityId, entityType, subEntityType, additionalArgs) { return __awaiter(void 0, void 0, void 0, function () {
    var config, entityTypeSuffix, url, _i, _a, _b, key, value;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = getMarketingDocumentsApiConfig();
                entityTypeSuffix = getProductTypeUrlSuffix(entityType, true);
                url = config.baseUrl + "/v1/" + entityTypeSuffix + "/" + entityId + "/" + subEntityType + "?marketLocale=" + config.marketLocale;
                if (additionalArgs) {
                    for (_i = 0, _a = Object.entries(additionalArgs); _i < _a.length; _i++) {
                        _b = _a[_i], key = _b[0], value = _b[1];
                        url += "&" + key + "=" + value;
                    }
                }
                return [4 /*yield*/, fetchGet(url)];
            case 1: return [2 /*return*/, _c.sent()];
        }
    });
}); };
